import { render, staticRenderFns } from "./DepartamentAddNew.vue?vue&type=template&id=e48be4d0"
import script from "./DepartamentAddNew.vue?vue&type=script&lang=js"
export * from "./DepartamentAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports